module.exports = "<link ng-repeat=\"reference in vm.stylesheetReferences\"\n  ng-href=\"{{reference.url}}\"\n  rel=\"stylesheet\" type=\"text/css\"/>\n\n<div class=\"app\" ng-class=\"{'app--debug': vm.appModel.debugOn}\">\n  <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 691
// module chunks = 0